<template>
    <div class="hts-filter-toggle">
        <hts-popover
            placement="bottom-start"
            :offset="[0, 0]"
            :arrow="false">
            <template #reference>
                <div
                    class="hts-filter-toggle__button"
                    :class="{ selected }">
                    <slot name="icon">
                        <hts-icons
                            :icon-name="iconName"
                            class="mr-1" />
                    </slot>
                    <span>
                        {{ label }}
                    </span>
                    <template v-if="selected">
                        <template v-if="!multiple">
                            <span class="mr-1">
                                :
                            </span>
                            <slot
                                v-if="selectedItem.icon || selectedItem.svg || selectedItem.iconName"
                                name="selected-icon">
                                <hts-icons
                                    :icon="selectedItem.icon"
                                    :svg="selectedItem.svg"
                                    :icon-name="selectedItem.iconName"
                                    :color="selectedItem.iconColor"
                                    class="mx-1" />
                            </slot>
                            <span
                                v-if="selectedItem[labelKey]"
                                class="mr-1 text-medium">
                                {{ selectedItem[labelKey] }}
                            </span>
                        </template>
                        <template v-else>
                            <span class="mx-1">
                                ({{ selectedLength }})
                            </span>
                        </template>
                    </template>
                    <div v-if="selected && clearable">
                        <hts-icons
                            icon-name="hi-x-mark-icon"
                            class="text-error-500 hover:text-error-600"
                            @click="handleClear" />
                    </div>
                </div>
            </template>
            <ul class="hts-filter-toggle__list">
                <template
                    v-for="(item, index) in (items as any)"
                    :key="index">
                    <li
                        class="hts-filter-toggle__list-item"
                        :class="{ selected: isSelected(item) }"
                        @click="handleSelect(item, $event)">
                        <slot
                            v-if="item.icon || item.svg || item.iconName"
                            name="item-icon">
                            <hts-icons
                                :icon="item.icon"
                                :svg="item.svg"
                                :icon-name="item.iconName"
                                :color="item.iconColor"
                                class="mr-1" />
                        </slot>
                        <span
                            v-if="item[labelKey]"
                            class="">
                            {{ item[labelKey] }}
                        </span>
                    </li>
                </template>
            </ul>
        </hts-popover>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: [Array, Number, String]
  },
  items: {
    type: Array,
    default: () => []
  },
  label: {
    type: String,
    default: 'Filter'
  },
  iconName: { type: String, default: 'hi-funnel-icon' },
  valueKey: {
    type: String,
    default: 'value'
  },
  labelKey: {
    type: String,
    default: 'label'
  },
  multiple: Boolean,
  clearable: {
    type: Boolean,
    default: true
  },
  readonly: Boolean,
  disabled: Boolean
})
const emits = defineEmits(['update:modelValue'])
const { modelValue, items, valueKey, labelKey, multiple, readonly, disabled } = toRefs(props)
const cValue = computed({
  get () {
    if (modelValue === undefined || modelValue.value === undefined) {
      return multiple.value ? [] : null
    }
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const selected = computed(() => {
  return selectedLength.value > 0
})
const selectedItem = computed(() => {
  return selectedLength.value > 0 ? selectedItems.value[0] : null
})
const selectedLength = computed(() => {
  return selectedItems.value.length
})
const selectedItems = computed<any[]>(() => {
  return items.value.filter((i: any) => isSelected(i))
})
const selectedLabels = computed(() => selectedItems.value.map((i: any) => i[labelKey.value] || '#'))

onBeforeMount(() => {
  if (multiple.value && !Array.isArray(cValue.value)) {
    cValue.value = []
  }
})
const handleSelect = (item: any, e: any) => {
  if (!item) {
    return
  }
  const tempValue = item[valueKey.value]
  if (multiple.value) {
    const existsIndex = cValue.value.findIndex((i: any) => i === tempValue)
    if (existsIndex >= 0) {
      cValue.value.splice(existsIndex, 1)
    } else {
      cValue.value.push(tempValue)
    }
  } else {
    cValue.value = tempValue
  }
}

const handleClear = (e: any) => {
  e && e.preventDefault()
  e && e.stopPropagation()
  if (multiple.value) {
    cValue.value = []
  } else {
    cValue.value = ''
  }
}

const isSelected = (item: any) => {
  if (!item) {
    return false
  }
  const tempValue = item[valueKey.value]
  if (tempValue === undefined) {
    return false
  }
  if (multiple.value) {
    return cValue.value.includes(tempValue)
  }
  return cValue.value === tempValue
}

const onChange = () => {}
</script>
